import {
  JiraPlaybookAriResourceOwner,
  JiraPlaybookAriResourceType
} from "./chunk-IVZ5YFMX.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/jira/playbook/manifest.ts
var jiraPlaybookAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: JiraPlaybookAriResourceOwner,
  resourceType: JiraPlaybookAriResourceType,
  resourceIdSlug: "activation/{activationId}/{playbookId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    // eslint-disable-line no-useless-escape
  }
};

// src/jira/playbook/index.ts
var JiraPlaybookAri = class _JiraPlaybookAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get playbookId() {
    return this._playbookId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: jiraPlaybookAriStaticOpts.qualifier,
      platformQualifier: jiraPlaybookAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: jiraPlaybookAriStaticOpts.resourceOwner,
      resourceType: jiraPlaybookAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        playbookId: opts.playbookId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, jiraPlaybookAriStaticOpts);
    return new _JiraPlaybookAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, jiraPlaybookAriStaticOpts);
    return new _JiraPlaybookAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      playbookId: this.playbookId
    };
  }
};

export {
  JiraPlaybookAri
};
